/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["file-list-header{display:flex;align-items:center;border-bottom:1px solid #e0e0e0;padding-bottom:8px;margin:0 28px;color:rgba(0,0,0,.87);max-height:49px}file-list-header toolbar-actions{margin-left:auto}@media only screen and (max-width:450px){file-list-header entries-sort-button .label,file-list-header entries-sort-button .sort-button-content{display:none}file-list-header entries-sort-button .mobile-sort-button-content{display:inline-block}}"];
export { styles as styles };
